import { render, staticRenderFns } from "./SearchModal.vue?vue&type=template&id=946af7cc&"
import script from "./SearchModal.vue?vue&type=script&lang=ts&"
export * from "./SearchModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports